/**
 * A way in which a session can be unlocked. Which ones are available depends on the session's
 * authenticators and on the browser.
 */
export type UnlockMethod = 'push' | 'securityKey' | 'mobileSafari';

/**
 * Availability of every unlock method. Every method is listed, so adding one does not silently
 * leave it unavailable wherever availability is determined.
 */
export type UnlockMethods = Readonly<{ [K in UnlockMethod]: boolean }>;

/**
 * How an unlock is represented to the user.
 */
export type UnlockDeviceType = 'phone' | 'mobileSafari' | 'multiple' | 'securityKey';

export function availableUnlockMethods(methods: UnlockMethods): UnlockMethod[] {
  return Object.entries(methods)
    .filter(([, available]) => available)
    .map(([method]) => method as UnlockMethod);
}

export function unlockDeviceTypeForMethods(methods: UnlockMethods): UnlockDeviceType {
  if (availableUnlockMethods(methods).length > 1) {
    return 'multiple';
  }
  if (methods.securityKey) {
    return 'securityKey';
  }
  if (methods.mobileSafari) {
    return 'mobileSafari';
  }
  return 'phone';
}
